import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AngularFirestore } from '@angular/fire/firestore';
import { DataService } from '../../data.service';
import { Booking } from '../../types';

@Component({
  selector: 'screening-dialog',
  templateUrl: 'screening.component.html',
  styleUrls: ['./screening.component.scss'],
})
export class ScreeningDialogComponent {
  temperature: number = 35;
  healthDeclaration: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<ScreeningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Booking,
    public dialog: MatDialog,
    public firestore: AngularFirestore,
    public dataService: DataService
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.temperature > 0 && this.healthDeclaration) {
      const data = {
        healthScreening: true,
        temperature: this.temperature,
      };
      this.firestore
        .collection('bookings')
        .doc(this.data.id)
        .update(data)
        .then((d) => {
          console.log(this.data.id);
          this.dialogRef.close();
        });
    } else {
      alert('Onvolledige vorm!');
    }
  }
}
